import { DEGREE_ADMISSION_STATUS } from '../common/common.constants';

const getRegistrationEndDateInFormat = (registration: { endDate: string | number | Date }) => {
  const endDate = new Date(registration.endDate);
  const day = endDate.getDate();
  const month = endDate.toLocaleString('en-US', { month: 'short' });
  const year = endDate.getFullYear().toString().slice(-2);

  // Function to get the ordinal suffix for the day
  const getOrdinalSuffix = (date: number) => {
    if (date >= 11 && date <= 13) {
      return 'th';
    }
    switch (date % 10) {
      case 1:
        return 'st';
      case 2:
        return 'nd';
      case 3:
        return 'rd';
      default:
        return 'th';
    }
  };

  // Format the date with the ordinal suffix for the day
  const formattedDate = `${`${day}'${getOrdinalSuffix(day)}`} ${month}, ${year}`;
  return formattedDate;
};

const getAdmissionStatus = (registration: { startDate: string; endDate: string }) => {
  let admissionStatus = '';

  if (registration && Object.keys(registration).length) {
    const currentDate = new Date(); // Current date and time

    if (currentDate < new Date(registration?.startDate)) {
      // Admission hasn't begun yet
      admissionStatus = DEGREE_ADMISSION_STATUS.BEGIN_SOON;
    } else if (currentDate >= new Date(registration?.endDate)) {
      // Admission is closed
      admissionStatus = DEGREE_ADMISSION_STATUS.CLOSED;
    } else {
      // Calculate the difference in days between endDate and currentDate
      const millisecondsPerDay = 24 * 60 * 60 * 1000;
      const differenceInDays =
        (new Date(registration?.endDate).getTime() - currentDate.getTime()) / millisecondsPerDay;
      if (differenceInDays <= 15) {
        // Closing soon condition: Start date is greater than today and end date is 15 days away
        admissionStatus = DEGREE_ADMISSION_STATUS.CLOSING_SOON;
      } else {
        // Default to open
        admissionStatus = DEGREE_ADMISSION_STATUS.OPEN;
      }
    }
  }
  return admissionStatus;
};

export { getRegistrationEndDateInFormat, getAdmissionStatus };
